<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <div class="card card-top-line">
          <ValidationObserver v-slot="{ passes }">
            <div class="header">
              <h2>Add Remitter Group</h2>
            </div>
            <form @submit.prevent="passes(remitterDataSubmit)" id="basic-form">
              <div class="body">
                <ValidationProvider
                  name="name"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group"
                    :class="{
                      errors: errors.length && !remitterGroup.name,
                      success: remitterGroup.name,
                    }"
                  >
                    <span class="float-label">
                      <input
                        type="text"
                        v-model="remitterGroup.name"
                        class="form-control"
                        id="name"
                        placeholder="Company Name*"
                      />
                      <label for="name" class="control-label">
                        Remitter Group Name*
                      </label>
                      <div class="line"></div>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && !remitterGroup.name"
                      ></i>
                      <i class="fa fa-check" v-if="remitterGroup.name"></i>
                    </span>
                  </div>
                </ValidationProvider>
                <div class="form-group">
                  <label class="control-label">
                    ID3 Band Text Options available*
                  </label>
                  <div class="body px-sm-0 pl-sm-4">
                    <ul class="list-unstyled mb-0 remitter-group-list">
                      <li v-for="(item, index) in ID3BandOptions" :key="index">
                        <div class="mb-4 d-flex">
                          <p
                            class="mb-0 text-danger font-16 mb-1 mb-md-0 mr-0 mr-md-4"
                          >
                            {{ item.name }}
                          </p>
                          <div class="custom-switch success-bg">
                            <input
                              type="checkbox"
                              class="custom-switch-input"
                              :id="`item${index}`"
                              v-model="item.enable"
                            />
                            <label
                              class="custom-switch-label"
                              :for="`item${index}`"
                            >
                              <span class="custom-switch-text1">Yes</span>
                              <span class="custom-switch-text2">No</span>
                            </label>
                          </div>
                        </div>
                        <div class="ml-0 ml-md-4 p-1 mb-2" v-if="item.enable">
                          <h6 class="font-14 font-weight-bold mb-3" for="title">
                            RemitOne and Other Options available*
                          </h6>
                          <div class="row ml-2">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label
                                  for="account_status"
                                  class="control-label font-weight-bold"
                                >
                                  Account Status
                                </label>
                                <div class="d-flex flex-column ml-3">
                                  <label class="fancy-radio">
                                    <input
                                      name="account_status"
                                      v-model="item.account_status"
                                      value="Not Validated"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Not Validated
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="account_status"
                                      v-model="item.account_status"
                                      value="Validated"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Validated
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="account_status"
                                      v-model="item.account_status"
                                      value="Validation Failed"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Validation Failed
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="account_status"
                                      v-model="item.account_status"
                                      value="No Change"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      No Change
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div class="form-group">
                                <label
                                  for="email_code"
                                  class="control-label font-weight-bold"
                                >
                                  Email Code
                                </label>
                                <div class="d-flex flex-column ml-3">
                                  <label class="fancy-radio">
                                    <input
                                      name="email_code"
                                      v-model="item.email_code"
                                      value="1001"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      1001
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="email_code"
                                      v-model="item.email_code"
                                      value="1002"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      1002
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="email_code"
                                      v-model="item.email_code"
                                      value="1003"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      1003
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="email_code"
                                      v-model="item.email_code"
                                      value="1004"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      1004
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="email_code"
                                      v-model="item.email_code"
                                      value="1005"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      1005
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="email_code"
                                      v-model="item.email_code"
                                      value="1006"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      1006
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="email_code"
                                      v-model="item.email_code"
                                      value="1007"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      1007
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="email_code"
                                      v-model="item.email_code"
                                      value="1008"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      1008
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div class="form-group">
                                <label
                                  for="is_login"
                                  class="control-label font-weight-bold"
                                >
                                  Is Login
                                </label>
                                <div class="d-flex flex-column ml-3">
                                  <label class="fancy-radio">
                                    <input
                                      name="is_login"
                                      v-model="item.is_login"
                                      value="yes"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Yes
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="is_login"
                                      v-model="item.is_login"
                                      value="no"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      No
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div class="form-group">
                                <label
                                  for="edit_res_country"
                                  class="control-label font-weight-bold"
                                >
                                  Edit Res Country
                                </label>
                                <div class="d-flex flex-column ml-3">
                                  <label class="fancy-radio">
                                    <input
                                      name="edit_res_country"
                                      v-model="item.edit_res_country"
                                      value="yes"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Yes
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="edit_res_country"
                                      v-model="item.edit_res_country"
                                      value="no"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      No
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div class="form-group">
                                <label
                                  for="edit_profile"
                                  class="control-label font-weight-bold"
                                >
                                  Edit Profile
                                </label>
                                <div class="d-flex flex-column ml-3">
                                  <label class="fancy-radio">
                                    <input
                                      name="edit_profile"
                                      v-model="item.edit_profile"
                                      value="yes"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Yes
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="edit_profile"
                                      v-model="item.edit_profile"
                                      value="no"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      No
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="edit_profile"
                                      v-model="item.edit_profile"
                                      value="yes bob only"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Yes DOB Only
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="edit_profile"
                                      v-model="item.edit_profile"
                                      value="not applicable"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Not Applicable
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="edit_profile"
                                      v-model="item.edit_profile"
                                      value="no change"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      No Change
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div class="form-group">
                                <label
                                  for="remit_type"
                                  class="control-label font-weight-bold"
                                >
                                  Remit Type
                                </label>
                                <div class="d-flex flex-column ml-3">
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_type"
                                      v-model="item.remit_type"
                                      value="not applicable"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Not Applicable
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_type"
                                      v-model="item.remit_type"
                                      value="registered"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Registered
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_type"
                                      v-model="item.remit_type"
                                      value="non-registered"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Non-Registered
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_type"
                                      v-model="item.remit_type"
                                      value="no change"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      No Change
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label
                                  for="remit_status"
                                  class="control-label font-weight-bold"
                                >
                                  Remit Status
                                </label>
                                <div class="d-flex flex-column ml-3">
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_status"
                                      v-model="item.remit_status"
                                      value="valid"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Valid
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_status"
                                      v-model="item.remit_status"
                                      value="blocked"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Blocked
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_status"
                                      v-model="item.remit_status"
                                      value="not applicable"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Not Applicable
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_status"
                                      v-model="item.remit_status"
                                      value="no change"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      No Change
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div class="form-group">
                                <label
                                  for="is_verified"
                                  class="control-label font-weight-bold"
                                >
                                  Is Verified
                                </label>
                                <div class="d-flex flex-column ml-3">
                                  <label class="fancy-radio">
                                    <input
                                      name="is_verified"
                                      v-model="item.is_verified"
                                      value="not applicable"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Not Applicable
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="is_verified"
                                      v-model="item.is_verified"
                                      value="yes"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Yes
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="is_verified"
                                      v-model="item.is_verified"
                                      value="no"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      No
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="is_verified"
                                      v-model="item.is_verified"
                                      value="no change"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      No Change
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div class="form-group">
                                <label
                                  for="remit_id_type"
                                  class="control-label font-weight-bold"
                                >
                                  Remit Id Type
                                </label>
                                <div class="d-flex flex-column ml-3">
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_id_type"
                                      v-model="item.remit_id_type"
                                      value="passport"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Passport
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_id_type"
                                      v-model="item.remit_id_type"
                                      value="insert doc used dynamically"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Insert Doc Used Dynamically
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_id_type"
                                      v-model="item.remit_id_type"
                                      value="no change"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      No Change
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div class="form-group">
                                <label
                                  for="remit_id_details"
                                  class="control-label font-weight-bold"
                                >
                                  Remit Id Details
                                </label>
                                <div class="d-flex flex-column ml-3">
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_id_details"
                                      v-model="item.remit_id_details"
                                      value="ID3V autoerified"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      ID3V autoVerified
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_id_details"
                                      v-model="item.remit_id_details"
                                      value="ID3V mVerify"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      ID3V mVerify
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_id_details"
                                      v-model="item.remit_id_details"
                                      value="ID3V Failed"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      ID3V Failed
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_id_details"
                                      v-model="item.remit_id_details"
                                      value="no change"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      No Change
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div class="form-group">
                                <label
                                  for="remit_id_expiry"
                                  class="control-label font-weight-bold"
                                >
                                  Remit Id Expiry
                                </label>
                                <div class="d-flex flex-column ml-3">
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_id_expiry"
                                      v-model="item.remit_id_expiry"
                                      value="14 Days"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      14 Days
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_id_expiry"
                                      v-model="item.remit_id_expiry"
                                      value="1 Month"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      1 Month
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_id_expiry"
                                      v-model="item.remit_id_expiry"
                                      value="1 Year"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      1 Year
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_id_expiry"
                                      v-model="item.remit_id_expiry"
                                      value="No Limit"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      No Limit
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_id_expiry"
                                      v-model="item.remit_id_expiry"
                                      value="Same Day"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      Same Day
                                    </span>
                                  </label>
                                  <label class="fancy-radio">
                                    <input
                                      name="remit_id_expiry"
                                      v-model="item.remit_id_expiry"
                                      value="no change"
                                      type="radio"
                                    />
                                    <span>
                                      <i></i>
                                      No Change
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="d-flex flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="$router.back()"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                  >
                    Submit
                  </b-button>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import "@/plugins/vee-validate";
import { mapState, mapGetters } from "vuex";
export default {
  name: "AddRemitterGroupComponent",
  components: {
    BreadCrumb,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      remitterGroup: {
        name: "",
        creditType: "",
      },
      ID3BandOptions: [
        {
          name: "PASS - with DOB",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "REFER",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "PASS - without DOB (PEP match)",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "PASS - with DOB (PEP match)",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "PASS & SSN - without DOB (PEP match)",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "PASS & SSN - with DOB (PEP match)",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "PASS & SSN - without DOB",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "PASS & SSN - with DOB",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "(Sanction match)",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "SSN only (PEP match)",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "ALERT",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "REFER - PEP Match",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "SSN only",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "PASS - without DOB",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "ID3 Error",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "REFER - Sanction Match",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "PASS - without DOB (Sanction Match)",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "PASS - without DOB (2+2) (Sanction Match)",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "REFER - Sanction Match",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "PASS - with DOB (Sanction Match)",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "REFER - PEP & Sanction Match",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "PASS - without DOB (PEP + Sanction Match)",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "PASS - without DOB (2+2) (PEP + Sanction Match)",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "REFER - PEP + Sanction Match",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "System Error",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "Exception",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "PASS - without DOB (2+2)",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "PASS - without DOB (2+2) (PEP Match)",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "PASS - with DOB (PEP + Sanction Match)",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "N/A",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
        {
          name: "PASS - only for GHANA",
          enable: false,
          account_status: "",
          email_code: "",
          is_login: "",
          edit_res_country: "",
          edit_profile: "",
          remit_type: "",
          remit_status: "",
          is_verified: "",
          remit_id_type: "",
          remit_id_details: "",
          remit_id_expiry: "",
        },
      ],
    };
  },
  methods: {
    remitterDataSubmit() {
      console.log(this.remitterGroup);
      console.log(this.selectedOptions);
    },
  },
  mounted() {},
  computed: {
    ...mapGetters(["isLoading"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
